var React = require('react');

function BoldChevronLeft (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M22.237 23.763 14.475 16l7.762-7.763-2.474-2.474L9.525 16l10.238 10.237 2.474-2.474Z","key":0}),React.createElement("path",{"d":"M0 0h32v32H0z","style":{"fill":"none"},"key":1})]);
}

BoldChevronLeft.defaultProps = {"xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"},"viewBox":"0 0 32 32"};

module.exports = BoldChevronLeft;

BoldChevronLeft.default = BoldChevronLeft;
